import React, { ReactElement } from 'react';
import {
  Col, Link, Row, Text,
} from 'idsk-react-components';
import './publikovanyTerminMobileTableItem.scss';
import routes from '../../../routing/routes';

interface Props {
  termin: string,
  preferovanyTermin: string,
  tezaurus: string,
  uuid: string,
}

const PublikovanyTerminMobileTableItem = ({
  termin,
  preferovanyTermin,
  tezaurus,
  uuid,
}: Props): ReactElement => (
  <Col className="publikovany-termin-mobile-table-item-row">
    <Row className="dokument-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">
          <div className="information-header-row">
            Termín
          </div>
        </Text>
      </div>
      <div className="two-thirds">
        <Link to={routes.tezaurus.detail.withParams(uuid)}>{termin}</Link>
      </div>
    </Row>
    <Row className="dokument-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">
          <div className="information-header-row">
            Preferovaný termín
          </div>
        </Text>
      </div>
      <div className="two-thirds">
        <Text type="p" className="dokument-detail-row-text">{preferovanyTermin}</Text>
      </div>
    </Row>
    <Row className="dokument-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">
          <div className="information-header-row">
            Tezaurus
          </div>
        </Text>
      </div>
      <div className="two-thirds">
        <Text type="p" className="dokument-detail-row-text">{tezaurus}</Text>
      </div>
    </Row>
  </Col>
);

export default PublikovanyTerminMobileTableItem;
